package br.com.htms.inspeccaocampo.platform

/** Quebra de linha para carimbo / caixas com largura limitada. */
object TextBoxWrap {
    fun wrap(text: String, maxChars: Int): List<String> {
        val limit = maxChars.coerceAtLeast(8)
        val clean = text.replace('\r', ' ').replace('\n', ' ').trim()
        if (clean.isEmpty()) return listOf("")
        val out = mutableListOf<String>()
        var remaining = clean
        while (remaining.isNotEmpty()) {
            if (remaining.length <= limit) {
                out += remaining
                break
            }
            var cut = remaining.lastIndexOf(' ', limit)
            if (cut < limit / 3) cut = limit
            out += remaining.take(cut).trimEnd()
            remaining = remaining.drop(cut).trimStart()
        }
        return out.ifEmpty { listOf("") }
    }

    fun wrapAll(lines: List<String>, maxChars: Int): List<String> =
        lines.flatMap { wrap(it, maxChars) }
}
